import { DataRoomStatus, dataRoomStatusValues } from 'further-types/data-room';

export const DataRoomStatusLabels: Record<DataRoomStatus, string> = {
  [DataRoomStatus.Live]: 'Live',
  [DataRoomStatus.Inactive]: 'Not live',
};

export const dataRoomStatusOptions = dataRoomStatusValues.map((value) => ({
  value,
  label: DataRoomStatusLabels[value],
}));
